const TWO_FOR_ONE = 'TWO_FOR_ONE';
const THREE_FOR_TWO = 'THREE_FOR_TWO';
const TWENTY_PERCENT = 'TWENTY_PERCENT';
const THIRTY_PERCENT = 'THIRTY_PERCENT';
const FORTY_PERCENT = 'FORTY_PERCENT';
const FREE_SHIPPING = 'FREE_SHIPPING';

/**
 * Returns short label for promo/offer tags (yellow box with icon).
 * Used by ProductMiniature, Gallery, and Product detail.
 */
export const promotionTranslate = promotion => {
  if (!promotion || !promotion.type) return 'oferta';
  switch (promotion.type) {
    case TWO_FOR_ONE:
      return '2x1';
    case THREE_FOR_TWO:
      return '3x2';
    case TWENTY_PERCENT:
      return '20% off';
    case THIRTY_PERCENT:
      return '30% off';
    case FORTY_PERCENT:
      return '40% off';
    case FREE_SHIPPING:
      return 'gratis';
    default:
      return 'oferta';
  }
};
